<!-- navItem „Buchungen“ — vertragsseitige Buchungen zu diesem Provisionssatz. -->
<div class="cp-provision-contract-agent-transactions">

    @if (!initialized) {
        <p-skeleton height="16rem"></p-skeleton>
    } @else if (!provisionContractAgentId) {
        <p-message severity="info" text="Kein Provisionssatz ausgewählt." styleClass="w-full"></p-message>
    } @else if (transactionsWidget) {
        <mvs-widget #transactionsWidgetRef [widgetData]="transactionsWidget"></mvs-widget>
    }

</div>
